/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { FileType } from '../model/fileType';
import { FileTypeCreateRequest } from '../model/fileTypeCreateRequest';
import { FileTypeKeys } from '../model/fileTypeKeys';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class FileTypeService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createFileType
     * Creates a new file type.
     * @param fileTypeCreateRequest the information needed to create the file type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileTypeCreateFileType(fileTypeCreateRequest: FileTypeCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<FileType>;
    public fileTypeCreateFileType(fileTypeCreateRequest: FileTypeCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileType>>;
    public fileTypeCreateFileType(fileTypeCreateRequest: FileTypeCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileType>>;
    public fileTypeCreateFileType(fileTypeCreateRequest: FileTypeCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fileTypeCreateRequest === null || fileTypeCreateRequest === undefined) {
            throw new Error('Required parameter fileTypeCreateRequest was null or undefined when calling fileTypeCreateFileType.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<FileType>(`${this.configuration.basePath}/fileTypes`,
            fileTypeCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteFileType
     * Deletes an existing file type by file type code.
     * @param fileTypeCode the file type code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileTypeDeleteFileType(fileTypeCode: string, observe?: 'body', reportProgress?: boolean): Observable<FileType>;
    public fileTypeDeleteFileType(fileTypeCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileType>>;
    public fileTypeDeleteFileType(fileTypeCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileType>>;
    public fileTypeDeleteFileType(fileTypeCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fileTypeCode === null || fileTypeCode === undefined) {
            throw new Error('Required parameter fileTypeCode was null or undefined when calling fileTypeDeleteFileType.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<FileType>(`${this.configuration.basePath}/fileTypes/${encodeURIComponent(String(fileTypeCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFileType
     * Gets an existing file type by file type code.
     * @param fileTypeCode the file type code
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileTypeGetFileType(fileTypeCode: string, observe?: 'body', reportProgress?: boolean): Observable<FileType>;
    public fileTypeGetFileType(fileTypeCode: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileType>>;
    public fileTypeGetFileType(fileTypeCode: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileType>>;
    public fileTypeGetFileType(fileTypeCode: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fileTypeCode === null || fileTypeCode === undefined) {
            throw new Error('Required parameter fileTypeCode was null or undefined when calling fileTypeGetFileType.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FileType>(`${this.configuration.basePath}/fileTypes/${encodeURIComponent(String(fileTypeCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getFileTypes
     * Gets a list of file type keys for all file types defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public fileTypeGetFileTypes(observe?: 'body', reportProgress?: boolean): Observable<FileTypeKeys>;
    public fileTypeGetFileTypes(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<FileTypeKeys>>;
    public fileTypeGetFileTypes(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<FileTypeKeys>>;
    public fileTypeGetFileTypes(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<FileTypeKeys>(`${this.configuration.basePath}/fileTypes`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
